__turbopack_context__.v({
  "className": "caveat_309fbaf8-module__ADgRZq__className",
});
